import { CreditLedgerEntryOverviewSchema, ObjectIdSchema } from '@weft/types';
import { oz } from '@weft/utils';

export const GetCreditLedgerOverviewResponseSchema = oz.object({
  id: ObjectIdSchema,
  balance: oz.number(),
  entriesOverviews: oz.array(CreditLedgerEntryOverviewSchema),
}).openapi('GetCreditLedgerOverviewResponse');

export type GetCreditLedgerOverviewResponse = oz.TypeOf<typeof GetCreditLedgerOverviewResponseSchema>;